module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div data-uid=\"")
    ; __append(escapeFn( file.uid ))
    ; __append("\" style=\"display: inline-block; margin: 2px;\" name=\"item\">\n	<a href=\"")
    ; __append(escapeFn( file.url ))
    ; __append("\" rel=\"")
    ; __append(escapeFn( group ))
    ; __append("\" name=\"file\" class=\"fancybox\"></a>\n	<span class=\"icon-12 icon-remove gl-pointer\" name=\"remove\"></span>\n</div>")
  }
  return __output.join("");

}